import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Firmas } from 'src/app/pages/panelControl/models/firmas';
import { DatosFirmaService } from 'src/app/pages/panelControl/services/datos-firma.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationMessageComponent } from 'src/app/shared/components/sqp-components/sqpMensajeConfirmacion/components/confirmation-message/confirmation-message.component';
import { PanelEliminarFirmasComponent } from '../panel-eliminar-firmas/panel-eliminar-firmas.component';
import { FiltroFirma } from 'src/app/shared/models/filtros';
import { DescargaMasivaModalComponent } from '../descarga-masiva-modal/descarga-masiva-modal.component';
import { GridColDefsData } from 'src/app/pages/panelControl/models/grid-col-defs-data';
import { ColDef } from 'ag-grid-community';
import { ExportadorPdfService } from 'src/app/shared/ExportadorFicheros/services/exportador-pdf.service';
import { ExportadorExcelService } from 'src/app/shared/ExportadorFicheros/services/exportador-excel.service';
import { DatosExcel } from 'src/app/shared/ExportadorFicheros/models/datos-excel';
import { DatosPdf } from 'src/app/shared/ExportadorFicheros/models/datos-pdf';
import { SpinnerModalComponent } from 'src/app/shared/components/others/spinner-modal/spinner-modal.component';
import { EstadosFirmaService } from '../../services/estados-firma.service';
import { DetalleFirmaComponent } from '../detalle-firma/detalle-firma.component';
import { TipoMensajeConfirmacion } from 'src/app/shared/components/sqp-components/sqpMensajeConfirmacion/models/confirmation-message-data';
import { FiltrosSelectorResumen } from 'src/app/shared/components/sqp-components/sqpSelectores/models/filtros-selector-resumen';
import { DesplegableData } from 'src/app/shared/components/sqp-components/sqpDesplegable/models/desplegable-data';
import { FiltroSqp, VisualizacionDestacada } from 'src/app/shared/components/sqp-components/sqpFiltroSuperior/models/filtro-sqp';
import { TipoFiltro } from 'src/app/shared/components/sqp-components/sqpFiltroSuperior/models/tipo-filtro';
import { SpinnerModalSqpComponent } from 'src/app/shared/components/sqp-components/sqpModales/spinner-modal-sqp/spinner-modal-sqp.component';
import { OrdenColumna } from 'src/app/shared/models/orden-columna';
import { TipoEnvio } from 'src/app/pages/configuracion/Envios/envios/models/tipo-envio';
import { CentrosModel } from 'src/app/pages/configuracion/maestros/centros/models/centros-model';
import { EmpresasModel } from 'src/app/pages/configuracion/maestros/empresas/models/empresas-model';
import { ResumenEstados } from '../../models/resumen-inicial';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ExportarExcelModalComponent } from '../exportar-excel-modal/exportar-excel-modal.component';
import { InformesExcel } from '../../models/informes-excel';
import { FormulariosInfo145 } from '../../models/formulariosInfo145';
import { DescargarExcelFormulariosService } from '../../services/descargar-excel-formularios.service';
import { ModalMessageComponent } from 'src/app/shared/components/modals/modal-message/modal-message.component';
import { CalendarioRangoService } from 'src/app/shared/components/sqp-components/sqpFiltroCalendario/services/calendario-rango.service';
import { RecuperaConfiguracionAplicacionApiService } from 'src/app/pages/configuracion/configuracion-rlt/services/recupera-configuracion-aplicacion-api.service';

@Component({
  selector: 'app-panel-de-control',
  templateUrl: './panel-de-control.component.html',
  styleUrls: ['./panel-de-control.component.css']
})
export class PanelDeControlComponent implements OnInit {

  firmas: any = []// Variable definida como any para que inicialmente se muestre el label de "Cargando" del grid. Posteriormente se cargará la lista de firmas
  columnDefs: ColDef[] = new GridColDefsData().columDefs;
  columnasaExcluir: string[] = ['esNueva', 'descargar'];
  columnasOcultasIncluirEnExport: string[] = ['mensaje'];
  columnasExclusivasExports: string[] = ['Documentos subidos', 'Documentos pendientes'];
  refrescando = false;
  tiposDosierLista: DesplegableData[];
  empresasLista: DesplegableData[];
  centrosLista: DesplegableData[];
  filtrosFirma: FiltroFirma[] = [];
  gridOptions: any = {
    getRowStyle: (params: any) => {
      if (params.data.EsNueva) return { fontWeight: "bold", backgroundColor: "var(--hs-yellow3)" };
      else return {};
    },
    suppressScrollOnNewData: true
  }
  filtrosSelectorResumen: FiltrosSelectorResumen[] = [
    { textoOpcion1: '', textoOpcion2: 'Sandbox', active: false, control: 'Sandbox' },
    { textoOpcion1: '', textoOpcion2: 'Ver sólo nuevos', active: false, control: 'Nuevos' }
  ]
  filtrosSqp: FiltroSqp[] = [];
  // primeraCarga: boolean = true;
  filtroFechaEnvio: FiltroSqp;
  ordenColumna: OrdenColumna;
  currentPage = 1; // Current page number
  hasMoreRows = true; // Flag to check if more rows are available
  isLoading = false; // Prevent duplicate requests
  private readonly maxPrefetchPages = 5;
  envios: TipoEnvio[] = [];
  centros: CentrosModel[] = [];
  empresas: EmpresasModel[] = [];
  resumenEstados: ResumenEstados[] = [];
  private readonly centroEmpresaSeparator = '||';
  gridSuppressSelectionEvents: any;
  dialogRefSpinner: any;
  mostrarFiltros: boolean = false;
  private firmasSubscription: any;
  private initialLoadDone: boolean = false;
  moduloDescargaFormulariosActivo = false;
  private moduloEnvioSimpleActivo = false;

    constructor(public datosFirmaService: DatosFirmaService,
    private router: Router, private route: ActivatedRoute,
    public dialog: MatDialog,
    private exportadorPdfService: ExportadorPdfService,
    private exportadorExcelService: ExportadorExcelService,
    public estadosFirmaService: EstadosFirmaService,
    private _snackBar: MatSnackBar,
    private descargarExcelFormulariosService: DescargarExcelFormulariosService,
    private calendarioRangoService: CalendarioRangoService,
    private recuperaConfiguracionAplicacionService: RecuperaConfiguracionAplicacionApiService) {
    const param = this.route.snapshot.paramMap.get('nuevos');
    if (param == 'nuevos') this.filtrosSelectorResumen[1].active = true; //this.verNuevasParam=true;
    this.filtroFechaEnvio = this.calendarioRangoService.getFiltroFechaEnvioPersistido()
      ?? this.datosFirmaService.montarFiltroFechaEnvio();
    this.filtrosSqp.push(this.filtroFechaEnvio);
    this.getDesplegablesFiltros();
  }

  ngOnInit(): void {
    this.cargarModulosActivos();
  }

  private cargarModulosActivos(): void {
    this.recuperaConfiguracionAplicacionService.getModulosActivos().subscribe({
      next: (result) => {
        this.moduloDescargaFormulariosActivo = result.ModuloDescargaFormulariosActivo ?? false;
        this.moduloEnvioSimpleActivo = result.ModuloEnvioSimpleActivo ?? false;
      },
      error: () => {
        this.moduloDescargaFormulariosActivo = false;
        this.moduloEnvioSimpleActivo = false;
      }
    });
  }

  //LLAMADAS A APIS PARA OBTENER LAS EMPRESAS, CENTROS, TIPOS DE DOSIER, RESUMEN DE ESTADOS Y FIRMAS

  getFirmasPaginacion(origen: string, closeSpinner: boolean = true, pageSize: number = 50, forceRefresh: boolean = false) {

    // Allow the call if it's a forced refresh (from refresh() method)
    if ((this.isLoading || !this.hasMoreRows) && !forceRefresh) return;

    // Unsubscribe from any ongoing request if forcing a refresh
    if (forceRefresh && this.firmasSubscription) {
      this.firmasSubscription.unsubscribe();
      this.firmasSubscription = null;
    }

    this.isLoading = true;
    // Only open spinner if one is not already open
    if (!this.dialogRefSpinner) {
      this.dialogRefSpinner = this.dialog.open(SpinnerModalSqpComponent);
    }
    this.fetchFirmasWithPrefetch(this.currentPage, [], 0, pageSize, forceRefresh, closeSpinner);
  }

  private fetchFirmasWithPrefetch(
    pageNumber: number,
    accumulated: any[],
    prefetchIndex: number,
    pageSize: number,
    forceRefresh: boolean,
    closeSpinner: boolean
  ): void {
    this.firmasSubscription = this.datosFirmaService
      .GetFirmas(this.filtrosSqp, pageNumber, pageSize, this.ordenColumna)
      .subscribe({
        next: (result) => {
          const merged = [...accumulated, ...(result.data ?? [])];
          const shouldPrefetch = result.hasMore
            && merged.length < pageSize
            && prefetchIndex + 1 < this.maxPrefetchPages;

          if (shouldPrefetch) {
            this.fetchFirmasWithPrefetch(pageNumber + 1, merged, prefetchIndex + 1, pageSize, forceRefresh, closeSpinner);
            return;
          }

          if (forceRefresh) {
            this.firmas = merged;
          } else {
            this.firmas = [...this.firmas, ...merged];
          }

          this.currentPage = result.pageNumber + 1;
          this.hasMoreRows = result.hasMore;

          if ((closeSpinner || !this.hasMoreRows) && this.dialogRefSpinner) {
            this.dialogRefSpinner.close();
            this.dialogRefSpinner = null;
          }
          this.isLoading = false;
          this.firmasSubscription = null;
        },
        error: (error) => {
          if (this.dialogRefSpinner) {
            this.dialogRefSpinner.close();
            this.dialogRefSpinner = null;
          }
          this.isLoading = false;
          this.firmasSubscription = null;
          if (error.status !== 401) this._snackBar.open(error.message, 'Cerrar', { duration: 4000 });
          console.error('Error loading rows:', error);
        }
      });
  }

  private abrirSpinnerExportacion(): void {
    if (!this.dialogRefSpinner) {
      this.dialogRefSpinner = this.dialog.open(SpinnerModalSqpComponent);
    }
  }

  private cerrarSpinnerExportacion(): void {
    if (this.dialogRefSpinner) {
      this.dialogRefSpinner.close();
      this.dialogRefSpinner = null;
    }
  }

  private ejecutarConFirmasCompletasSiNecesario(accion: () => void | Promise<void>, reutilizarSpinner = false): void {
    if (!this.hasMoreRows) {
      void Promise.resolve(accion());
      return;
    }

    if (!reutilizarSpinner || !this.dialogRefSpinner) {
      this.dialogRefSpinner = this.dialog.open(SpinnerModalSqpComponent);
    }
    this.datosFirmaService.GetFirmas(this.filtrosSqp, 0, 0, this.ordenColumna).subscribe({
      next: (result) => {
        this.firmas = [...(result.data ?? [])];
        this.hasMoreRows = false;
        void Promise.resolve(accion());
      },
      error: (error) => {
        console.error('Error cargando firmas completas', error);
        if (this.dialogRefSpinner) {
          this.dialogRefSpinner.close();
          this.dialogRefSpinner = null;
        }
      }
    });
  }

  loadRows() {
    if (this.isLoading || !this.hasMoreRows) return;
    this.getFirmasPaginacion('scroll', true, 50);
  }

  ordenarGrid(event: OrdenColumna) {
    this.ordenColumna = event;
    this.refresh('ordenar');
  }

  getResumenEstados(origen: string) {
    this.datosFirmaService.getResumenEstados(this.filtrosSqp).subscribe({
      next: (response: any) => {
        this.resumenEstados = response;
      },
      error: (error) => {
        console.error('Error loading rows:', error);
      }
    })
  }

  //FIN LLAMADAS A APIS PARA OBTENER LAS EMPRESAS, CENTROS, TIPOS DE DOSIER, RESUMEN DE ESTADOS Y FIRMAS

  //#region Acciones barra superior

  clickBarraSuperior(id: string) {
    switch (id) {
      case "Descargar":
        this.descargarFirmasGrid();
        break;
      case 'Excel':
        this.descargarExcel();
        break;
      case "Eliminar":
        this.eliminarFirmas();
        break;
      case "Pdf":
        this.exportaPdf();
        break;
      default:
        break;
    }
  }

  eliminarFirmas() {
    if (this.firmas) {
      let firmasError = this.firmas.filter((x: Firmas) => x.estadoString == "Error");
      const dialogRef = this.dialog.open(PanelEliminarFirmasComponent, {
        data: firmasError,
        position: { right: '0' },
        panelClass: 'modal-class'
      });
      dialogRef.afterClosed().subscribe(result => {
        if (typeof result == 'number') {
          this.refresh();
        }
      });
    }
  }

  descargarFirmasGrid() {
    if (this.firmas) {
      const dialogRef = this.dialog.open(ConfirmationMessageComponent, {
        data: {
          tipo: TipoMensajeConfirmacion.ConfirmacionSimple,
          icono: 'hs-download',
          titulo: 'Descargar documentos',
          mensaje: '<p>Descarga los certificados de firma y los documentos firmados de los registros mostrados en el listado</p>',
          textoConfirmacion: 'Descargar',
          iconoConfirmacion: 'hs-download',
          textoCancelar: 'cancelar'
        },
        autoFocus: 'dialog'
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result === 'OK') {
          this.ejecutarConFirmasCompletasSiNecesario(() => {
            const idsFirmas = this.firmas
              .filter((x: Firmas) => x.estadoString === 'Firmado' || x.estadoString === 'Parcialmente firmado')
              .map((x: Firmas) => x.idFirma);
            this.dialog.open(DescargaMasivaModalComponent, { data: { ids: idsFirmas } });
          });
        }
      });
    }
  }

  descargarExcel() {
    if (this.moduloDescargaFormulariosActivo) {
      this.abrirModalDescargarExcel();
      return;
    }

    this.exportaExcelGeneral([
      { nombre: 'Exportación general firmas', seleccionado: true }
    ]);
  }

  abrirModalDescargarExcel() {
    this.dialog.open(ExportarExcelModalComponent, {
      data: {
        titulo: 'Tipo de contenido a exportar',
        informesExcel: [
          { nombre: 'Exportación general firmas', seleccionado: false },
          { nombre: 'Formularios', seleccionado: false }
        ]
      }
    }).afterClosed().subscribe(result => {
      if (result) {
        const seleccionGeneral = result.some(x => x.nombre === 'Exportación general firmas');
        const seleccionFormularios = result.some(x => x.nombre === 'Formularios');
        if (seleccionGeneral) this.exportaExcelGeneral(result);
        else if (seleccionFormularios) this.getInfoFormularios();
      }
    });
  }

  getInfoFormularios(opciones?: { mantenerSpinnerActivo?: boolean }): void {
    const mantenerSpinnerActivo = opciones?.mantenerSpinnerActivo ?? false;

    if (!mantenerSpinnerActivo) {
      this.abrirSpinnerExportacion();
    }

    this.datosFirmaService.getDatosFormularios(this.filtrosSqp).subscribe({
      next: (response: any) => {
        this.cerrarSpinnerExportacion();

        if (response.length > 0) {
          this.dialog.open(ExportarExcelModalComponent, {
            data: {
              titulo: 'Lista agrupada',
              informesExcel: response
            }
          }).afterClosed().subscribe(result => {
            if (result) {
              this.exportaExcelFormularios(result);
            }
          });
        } else {
          this.dialog.open(ModalMessageComponent, {
            data: {
              alert: true,
              mensaje: 'No hay formularios para exportar'
            }
          });
        }
      },
      error: (error) => {
        this._snackBar.open(error.message, 'Cerrar', { duration: 4000 });
        this.cerrarSpinnerExportacion();
      }
    });
  }

  exportaExcelGeneral(informesSeleccionados: InformesExcel[]) {
    let excelFormularios = false;
    if (informesSeleccionados.find(x => x.nombre == 'Formularios')) excelFormularios = true;

    if (this.firmas) {
      const dialogRef = this.dialog.open(ConfirmationMessageComponent, {
        data: {
          tipo: TipoMensajeConfirmacion.ConfirmacionSimple,
          icono: 'icon-excel-empty',
          titulo: 'Generar excel',
          mensaje: '<p>Genera un documento Excel con la información de los registros mostrados en el listado.</p>' + (excelFormularios ? '<p>También se mostrarán los diferentes tipos de formularios y campos editables que contengan los documentos añadidos en las firmas para poderlos descargar en un excel posteriormente.</p>' : ''),
          textoConfirmacion: 'Aceptar',
          iconoConfirmacion: 'icon-excel-empty',
          textoCancelar: 'cancelar'
        },
        autoFocus: 'dialog'
      });

      let datosExcel = this.montarParametrosExcel();

      dialogRef.afterClosed().subscribe(result => {
        if (result === 'OK') {
          if (excelFormularios) {
            this.exportaExcelGeneralYFormularios(datosExcel);
          } else {
            this.ejecutarConFirmasCompletasSiNecesario(() => this.ejecutarExportacionExcel(datosExcel));
          }
        }
      });
    }
  }

  private exportaExcelGeneralYFormularios(datosExcel: DatosExcel): void {
    this.abrirSpinnerExportacion();
    this.ejecutarConFirmasCompletasSiNecesario(() => {
      return this.ejecutarExportacionExcel(datosExcel, undefined, false)
        .then(() => this.getInfoFormularios({ mantenerSpinnerActivo: true }))
        .catch(() => this.cerrarSpinnerExportacion());
    }, true);
  }

  exportaExcelFormularios(infoForms: FormulariosInfo145[]): void {
    this.abrirSpinnerExportacion();
    this.datosFirmaService.getFormulariosExcel(this.filtrosSqp, infoForms).subscribe({
      next: (response: any) => {
        this.descargarExcelFormulariosService.montarExcelFormularios(response)
          .finally(() => this.cerrarSpinnerExportacion());
      },
      error: (error) => {
        const mensaje = error?.message ?? error;
        console.error("Error exportando a excel", mensaje);
        this._snackBar.open(`Error exportando a excel: ${mensaje}`, 'Cerrar', { duration: 4000 });
        this.cerrarSpinnerExportacion();
      }
    });
  }

  private ejecutarExportacionExcel(datosExcel: DatosExcel, rowsMontadas?: any[], cerrarSpinner = true): Promise<void> {
    if (rowsMontadas) {
      this.exportadorExcelService.exportaExcel(datosExcel, rowsMontadas);
      if (cerrarSpinner) {
        this.cerrarSpinnerExportacion();
      }
      return Promise.resolve();
    }

    const abort = new AbortController();
    return this.datosFirmaService.GetDatosExtraFirmas(abort.signal).then(() => {
      const rows = this.GetRowsExportExcel(this.firmas, datosExcel.columnas);
      this.exportadorExcelService.exportaExcel(datosExcel, rows);
      if (cerrarSpinner) {
        this.cerrarSpinnerExportacion();
      }
    }).catch((error: any) => {
      console.error("Error exportando a excel", error);
      if (cerrarSpinner) {
        this.cerrarSpinnerExportacion();
      }
      this.hasMoreRows = false;
      throw error;
    });
  }

  private ejecutarExportacionPdf(datos: DatosPdf) {
    let abort: AbortController = new AbortController();
    this.datosFirmaService.GetDatosExtraFirmas(abort.signal).then(() => {
      //escogemos la fecha a mostrar y la convertimos a formato correcto
      this.firmas.forEach((x: any) => {
        x._fechaCreacion = this.formatFechaExport(x.fechaCreacion ?? x.fechaUltimaActualizacion);
        x._fechaFirma = this.formatFechaExport(x.fechaFirma ?? x.fechaEnvio ?? x.fechaUltimaActualizacion);
        if (x.estadoRlt == null) x.estadoRlt = '';
        else if (x.estadoRlt) x.estadoRlt = 'Enviado';
        else if (!x.estadoRlt) x.estadoRlt = 'Pendiente';
        if (!x.nombreCentro?.includes(" - ")) x.nombreCentro = `${x.codigoCentro} - ${x.nombreCentro}`
        if (!x.nombreEmpresa?.includes(" - ")) x.nombreEmpresa = `${x.codigoEmpresa} - ${x.nombreEmpresa}`
        x._fechaContrato = this.formatFechaExport(x.fechaContrato);
      });

      this.exportadorPdfService.exportaPdf(datos, this.firmas);
      if (this.dialogRefSpinner) {
        this.dialogRefSpinner.close();
      }
    }).catch((error: any) => {
      console.error("Error exportando a pdf", error);
      if (this.dialogRefSpinner) {
        this.dialogRefSpinner.close();
      }
    });
  }

  montarParametrosExcel(): DatosExcel {
    let fecha = new Date();
    let datosExcel = {
      workSheetName: 'Firmas',
      nombreFichero: `Hire&Sign_envios_${fecha.getFullYear()}${fecha.getMonth() + 1}${fecha.getDate()}${fecha.getHours()}${fecha.getMinutes()}${fecha.getSeconds()}.xlsx`,
      columnas: this.GetColumnsExportExcel()
    }
    return datosExcel
  }

  private getMensajeExport(firma: Firmas): string {
    if (firma.estadoString === 'Error' || firma.estadoString === 'Borrador') {
      return firma.mensaje ?? '';
    }
    return '';
  }

  private formatFechaExport(fecha: Date | string | null | undefined): string {
    if (fecha == null) return '';
    return new Date(fecha).toLocaleDateString('en-GB');
  }

  private incluirColumnaEnExport(colDef: ColDef, incluirColumnasOcultas = false): boolean {
    const field = colDef.field ?? '';
    if (this.columnasaExcluir.includes(field)) return false;
    if (!colDef.hide) return true;
    return incluirColumnasOcultas && this.columnasOcultasIncluirEnExport.includes(field);
  }

  //Generamos las columnas basandonos en las del grid
  GetColumnsExportExcel(): any[] {
    let columns: any[] = [];
    this.columnDefs.forEach((x) => {
      if (this.incluirColumnaEnExport(x, true)) {
        let element: any = {};
        element.name = x.headerName;
        element.filterButton = true;
        element.width = x.width;
        columns.push(element);
      }
    });
    return columns;
  }

  GetRowsExportExcel(data: Firmas[], columnas: any[]): any[] {
    let rows: any[] = [];
    data.forEach(x => {
      let fechaEnvio = x.fechaFirma ?? x.fechaEnvio ?? x.fechaUltimaActualizacion;
      // let estadoRlt = x.estadoRlt ? 'Enviado':'Pendiente';
      let estadoRlt;
      if (x.estadoRlt == null) estadoRlt = '';
      else if (x.estadoRlt) estadoRlt = 'Enviado';
      else if (!x.estadoRlt) estadoRlt = 'Pendiente';
      let row: any[] = [];
      columnas.forEach((y: any) => {
        switch (y.name) {
          case 'Estado': row.push(x.estadoString); break;
          case 'Firmante principal': row.push(x.empleado); break;
          case 'Fecha creación': row.push(this.formatFechaExport(x.fechaCreacion ?? x.fechaUltimaActualizacion)); break;
          case 'Fecha envío/firma': row.push(this.formatFechaExport(fechaEnvio)); break;
          case 'Tipo de dosier': row.push(x.tipoEnvio); break;
          case 'Centro':
            row.push(`${x.codigoCentro ?? ''} - ${x.nombreCentro ?? ''}`);
            break;
          case 'Empresa':
            if (!x.nombreEmpresa?.includes(" - ")) row.push(`${x.codigoEmpresa} - ${x.nombreEmpresa}`);
            else row.push(x.nombreEmpresa);
            break;
          case 'Email': row.push(x.emailEmpleado); break;
          case 'Teléfono': row.push(x.telefonoEmpleado); break;
          case 'Docs': row.push(x.numeroDocumentos); break;
          case 'RLT': row.push(estadoRlt); break;
          case 'Fecha contrato': row.push(this.formatFechaExport(x.fechaContrato)); break;
          case 'DNI': row.push(x.nifEmpleado); break;
          case 'Mensaje (Error)': row.push(this.getMensajeExport(x)); break;
          default: row.push(''); break;
        }

      });
      rows.push(row);
    });
    return rows
  }

  exportaPdf() {
    if (this.firmas) {
      const dialogRef = this.dialog.open(ConfirmationMessageComponent, {
        data: {
          tipo: TipoMensajeConfirmacion.ConfirmacionSimple,
          icono: 'icon-pdf-empty',
          titulo: 'Generar PDF',
          mensaje: '<p>Genera un documento PDF con la información de los registros mostrados en el listado</p>',
          textoConfirmacion: 'Generar PDF',
          iconoConfirmacion: 'icon-pdf-empty',
          textoCancelar: 'cancelar'
        },
        autoFocus: 'dialog'
      });

      //montamos el objeto a pasar al servicio con el modelo DatosPdf
      const datos = this.montarParametrosPdf()

      dialogRef.afterClosed().subscribe(result => {
        if (result === 'OK') {
          this.ejecutarConFirmasCompletasSiNecesario(() => this.ejecutarExportacionPdf(datos));
        }
      });
    }
  }

  montarParametrosPdf(): DatosPdf {
    let fecha = new Date();
    let columns: any[] = [];
    this.columnDefs.forEach(x => {
      if (this.incluirColumnaEnExport(x)) {
        if (x.field?.toLocaleLowerCase().includes("fecha")) columns.push({ header: x.headerName, dataKey: `_${x.field}` });
        else columns.push({ header: x.headerName, dataKey: x.field });
      }
    });
    //montamos el objeto a pasar al servicio
    let datosPdf = {
      landscape: true,
      nombreFichero: `Hire&Sign_envios_${fecha.getFullYear()}${fecha.getMonth() + 1}${fecha.getDate()}${fecha.getHours()}${fecha.getMinutes()}${fecha.getSeconds()}.pdf`,
      registros: columns
    }
    return datosPdf
  }

  refresh(origen: string = 'refresh') {
    this.currentPage = 1;
    this.firmas = [];
    this.hasMoreRows = true;
    this.gridSuppressSelectionEvents = true;

    // Cancel any ongoing request
    if (this.firmasSubscription) {
      this.firmasSubscription.unsubscribe();
      this.firmasSubscription = null;
    }

    // Reset loading state to allow new request
    this.isLoading = false;

    // Close existing spinner if open, then open a new one
    if (this.dialogRefSpinner) {
      this.dialogRefSpinner.close();
      this.dialogRefSpinner = null;
    }
    this.dialogRefSpinner = this.dialog.open(SpinnerModalSqpComponent);
    this.getResumenEstados(origen);
    // Force refresh by passing forceRefresh = true
    this.getFirmasPaginacion(origen, true, 50, true);
  }

  irASubida() {
    this.router.navigate(['/panel/subida']);
  }


  dialogRefSpinnerAbrirModal: any;

  selectRowChanged(event: any) {

    //SI ES UN ELMENTO QUE SE PUEDE CLICKAR NO HACEMOS NADA
    if (event.event.target.classList.contains('clickable')) return;

    let firma: Firmas = event.data;

    if (!firma.cargaCompleatada) {
      const i = this.datosFirmaService.firmas.findIndex(x => x.idFirma == firma.idFirma);
      this.dialogRefSpinnerAbrirModal = this.dialog.open(SpinnerModalComponent);
      this.datosFirmaService.GetDatosExtraFirmaCall(i).then(resp => {
        this.abreModal(this.datosFirmaService.firmas[i]);
      })
    } else {
      this.abreModal(firma);
    }

  }
  private abreModal(firma: Firmas) {
    this.dialogRefSpinnerAbrirModal.close();
    const dialogRef = this.dialog.open(DetalleFirmaComponent, {
      data: firma,
      panelClass: 'modal-class-detalle',
      position: { right: '0' }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.refresh) {
        this.refresh();
      }
    })
  }

  //FILTROS SQP (LATERAL Y SUPERIOR)

  montarListaFiltrosSqp() {
    this.filtrosSqp = [];
    this.filtrosSqp = [
      {
        tipoFiltro: TipoFiltro.TEXTO,
        titulo: 'Buscar',
        valoresSeleccionados: { valorString: '' }
      },
      {
        tipoFiltro: TipoFiltro.PASTILLA,
        titulo: 'Nuevos',
        valoresSeleccionados: { valorBool: this.filtrosSelectorResumen[1].active }
      },
      {
        tipoFiltro: TipoFiltro.PASTILLA,
        titulo: 'Sandbox',
        valoresSeleccionados: { valorBool: false },
        visualizacionDestacada: VisualizacionDestacada.TEST
      },
      {
        tipoFiltro: TipoFiltro.DESPLEGABLE_MULTI,
        titulo: 'Tipo dosier',
        valoresDesplegable: this.tiposDosierLista
      },
      {
        tipoFiltro: TipoFiltro.DESPLEGABLE_MULTI,
        titulo: 'Empresa',
        valoresDesplegable: this.empresasLista
      },
      {
        tipoFiltro: TipoFiltro.DESPLEGABLE_MULTI,
        titulo: 'Centro',
        valoresDesplegable: this.centrosLista
      },
      {
        tipoFiltro: TipoFiltro.TEXTO,
        titulo: 'Estado',
        valoresSeleccionados: { valorString: '' }
      },
      {
        tipoFiltro: TipoFiltro.FECHA,
        titulo: 'Fecha de envío',
        valoresSeleccionados: {
          valorFechaDesde: this.filtroFechaEnvio.valoresSeleccionados.valorFechaDesde,
          valorFechaHasta: this.filtroFechaEnvio.valoresSeleccionados.valorFechaHasta
        }
      },
      {
        tipoFiltro: TipoFiltro.FECHA,
        titulo: 'Fecha contrato',
        valoresSeleccionados: {
          valorFechaDesde: null,
          valorFechaHasta: null
        }
      }
    ];
  }

  actualizarFiltrosDesdeFiltroSuperior(event: FiltroSqp) {
    if (event) { //el evento puede venir undefined cuando se hace limpiar todo
      let index = this.filtrosSqp.findIndex(x => x.titulo == event.titulo)
      if (index == -1) this.filtrosSqp.push(event);
      else this.filtrosSqp[index] = event;

      if (event.titulo == 'Nuevos' || event.titulo == 'Sandbox') {
        this.filtrosSelectorResumen.find(x => event.titulo == x.control).active = event.valoresSeleccionados.valorBool;
      }
      if (event.titulo == 'Fecha de envío') {
        this.filtroFechaEnvio = {
          tipoFiltro: TipoFiltro.FECHA,
          titulo: 'Fecha de envío',
          valoresSeleccionados: {
            valorFechaDesde: event.valoresSeleccionados.valorFechaDesde,
            valorFechaHasta: event.valoresSeleccionados.valorFechaHasta
          }
        }
      }
      // Solo hacer refresh si ya se completó la carga inicial
      // Esto evita que se llame dos veces en el primer load
      if (this.initialLoadDone) {
        this.refresh('filtros');
      }
    }
  }

  borrarFiltros() {
    this.filtrosSelectorResumen.forEach(x => x.active = false);
    this.estadosFirmaService.estadoSeleccionado = 'TODOS';
    this.calendarioRangoService.limpiarFiltroFechaEnvio();
    this.filtroFechaEnvio = this.datosFirmaService.montarFiltroFechaEnvio();
    this.montarListaFiltrosSqp();
    this.refresh('borrar filtros');
  }

  clickDesdeFiltroLateralSqp(seleccion: FiltrosSelectorResumen) {
    this.filtrosSelectorResumen.find(x => seleccion.control == x.control).active = seleccion.active;
    this.filtrosSqp.find(x => x.titulo == seleccion.control).valoresSeleccionados.valorBool = seleccion.active;
    this.refresh('lateral click');
  }

  actualizarFiltrosDesdeFiltroLateralSqpEstado(estado: string) {
    this.filtrosSqp.find(x => x.titulo == 'Estado').valoresSeleccionados.valorString = this.estadosFirmaService.estadoSeleccionado;
    // Solo hacer refresh si ya se completó la carga inicial
    // Esto evita que se llame dos veces cuando se accede desde el menú principal con un estado seleccionado
    if (this.initialLoadDone) {
      this.refresh('lateral filtros');
    }
  }

  getDesplegablesFiltros() {
    this.datosFirmaService.getDesplegablesFiltros().subscribe((response: any) => {
      this.recuperaConfiguracionAplicacionService.getModulosActivos().subscribe({
        next: (modulos) => {
          this.moduloEnvioSimpleActivo = modulos.ModuloEnvioSimpleActivo ?? false;
          this.moduloDescargaFormulariosActivo = modulos.ModuloDescargaFormulariosActivo ?? false;
          this.aplicarDesplegablesFiltros(response);
        },
        error: () => {
          this.moduloEnvioSimpleActivo = false;
          this.aplicarDesplegablesFiltros(response);
        }
      });
    });
  }

  private aplicarDesplegablesFiltros(response: any) {
      const dosieres = (response?.Dosieres ?? []).filter((x: any) => {
        const esEnvioSimple = x?.EsEnvioSimple === true || x?.esEnvioSimple === true;
        return this.moduloEnvioSimpleActivo || !esEnvioSimple;
      });
      // id como string: drop-down-universal-sqp (@squarepoint/sqp-ui) usa id.toLowerCase() internamente
      this.tiposDosierLista = dosieres.map(x => ({
        id: x.IdTipoEnvio != null ? String(x.IdTipoEnvio) : (x.IdV3TipoEnvio ?? x.idTipoEnvio ?? x.idV3TipoEnvio ?? ''),
        desc: x.Nombre ?? x.nombre
      }));
      this.centrosLista = response.Centros.map(x => ({
        id: `${x.CodigoEmpresa}${this.centroEmpresaSeparator}${x.CodigoCentro}`,
        desc: (x.NombreCentro == null)
          ? `${x.CodigoCentro} (${x.CodigoEmpresa})`
          : `${x.CodigoCentro} - ${x.NombreCentro} (${x.CodigoEmpresa})`
      }));
      this.empresasLista = response.Empresas.map(x => ({ id: x.CodigoEmpresa, desc: (x.NombreEmpresa == null) ? x.CodigoEmpresa : `${x.CodigoEmpresa} - ${x.NombreEmpresa}` }));
      this.montarListaFiltrosSqp();
      this.mostrarFiltros = true;

      // Si hay un estado seleccionado (viene del menú principal), aplicarlo antes de la carga inicial
      if (this.estadosFirmaService.estadoSeleccionado && this.estadosFirmaService.estadoSeleccionado !== 'TODOS') {
        const estadoFilter = this.filtrosSqp.find(x => x.titulo == 'Estado');
        if (estadoFilter) {
          estadoFilter.valoresSeleccionados.valorString = this.estadosFirmaService.estadoSeleccionado;
        }
      }

      // Cargamos datos iniciales (firmas + resumen) con los filtros por defecto
      this.refresh('desplegables');
      // Marcar que la carga inicial está completa después de un pequeño delay
      // para permitir que los eventos de inicialización del filtro se procesen primero
      setTimeout(() => {
        this.initialLoadDone = true;
      }, 100);
  }
}
